import React from 'react'

const Thanks = () => (
  <div className="tbg" style={{ textAlign: 'center' }}>
    <h1 style={{ padding: '40px' }}>Thanks!</h1>
    <h2> We'll let you know when everyone has made their picks.</h2>
  </div>
)
export default Thanks
